import { getFramework, HotkeyType } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type IRenderContextMenuItemArgs } from '@/plugins/context-menu';
import { type ClipboardPlugin } from '../../controller';

export const clipboardCopyItem = (
    { activeLayer, pickLayer, isImageEditor }: IRenderContextMenuItemArgs,
    identity: string,
) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;
    let disabled = !layer;

    if (isImageEditor && disabled) return null;
    if (isImageEditor && activeLayer) {
        disabled = framework.service.behavior.get(activeLayer)?.checkDisableCopy?.(activeLayer) ?? false;
    }

    const type = HotkeyType.COPY;
    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.copy),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            const clipboard = framework.service.registration.getInstance<ClipboardPlugin>('ClipboardPlugin');
            if (!clipboard) {
                throw new Error('ClipboardPlugin is not found');
            }
            clipboard.copy();
        },
    };

    return item;
};
